/**
 * Med% and its change, shared by both matrix components.
 *
 * Med% is the median of a row's cell percentiles with the diagonal counted as
 * 50 — the notebook's np.median(current_perc.iloc[i]), whose diagonal series is
 * all zeros and so scores 50. The backend's reference Med%
 * (routes/spreads.js rowMedianPercentiles) uses the same definition, which is
 * what makes the delta between the two meaningful. A row with no scored cell
 * has no Med% (null), on both sides.
 */
export function medianRowPercentile(ticker1, tickers, row, getPercentile) {
  const vals = [];
  let hasData = false;
  for (const t of tickers) {
    if (t === ticker1) { vals.push(50); continue; }
    const p = getPercentile(row ? row[t] : null);
    if (p !== null && p !== undefined && !Number.isNaN(p)) { vals.push(p); hasData = true; }
  }
  // A row with no scored cell (no history, or data still loading) has no Med%;
  // the lone diagonal would otherwise report a confident-looking 50.00%.
  if (!hasData) return null;
  vals.sort((a, b) => a - b);
  const mid = Math.floor(vals.length / 2);
  return vals.length % 2 ? vals[mid] : (vals[mid - 1] + vals[mid]) / 2;
}

export function medPercDelta(current, reference) {
  if (current == null || reference == null) return null;
  return current - reference;
}

export function formatDelta(delta) {
  if (delta == null) return '-';
  const rounded = Math.round(delta * 100) / 100;
  if (rounded === 0) return '0.00';
  return `${rounded > 0 ? '+' : '−'}${Math.abs(rounded).toFixed(2)}`;
}

// Rising Med% means the row got richer against the list (red, like the matrix
// palette); falling means cheaper (green).
export function deltaColor(delta, isDarkMode) {
  if (delta == null || Math.round(delta * 100) === 0) return 'inherit';
  if (delta > 0) return isDarkMode ? '#ff8a80' : '#c62828';
  return isDarkMode ? '#69f0ae' : '#2e7d32';
}

export function deltaTitle(referenceSession) {
  return referenceSession
    ? `Change in Med% since the ${referenceSession} close`
    : 'Change in Med% (loading reference close…)';
}
